import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/css/Header.css';

export default class Header extends Component {

    state = {
        navOpen: false
    };

    openNav = () => {

        this.setState({ navOpen: true });
    }

    closeNav = () => {

        this.setState({ navOpen: false });
    }

    renderDropdown() {

        if (!this.state.navOpen) {
            return null;
        }

        return (
            <div id="navDrawer" className="overlay" onClick={this.closeNav}>
                <div className="overlay-content">
                    <Link to="/" className="overlay-link" onClick={this.closeNav}>HOME</Link>
                    <Link to="/music" className="overlay-link" onClick={this.closeNav}>MUSIC</Link>
                    <Link to="/shows" className="overlay-link" onClick={this.closeNav}>SHOWS</Link>
                    <Link to="/news" className="overlay-link" onClick={this.closeNav}>NEWS</Link>
                    <Link to="/about" className="overlay-link" onClick={this.closeNav}>ABOUT</Link>
                    <Link to="/contact" className="overlay-link" onClick={this.closeNav}>CONTACT</Link>
                    <a href="http://shop.flaural.co/" className="overlay-link" target="_blank" rel="noopener noreferrer" alt="flaural store">STORE</a>
                </div>
            </div>
        );
    }

    render() {

        let navClass = this.state.navOpen ? 'open' : 'notOpen';

        return (
            <div className="Header">
                <div className={`${navClass} activator-container`}>
                    <span onClick={this.state.navOpen ? this.closeNav : this.openNav}>
                        <button type="button" name="button" id="open-me">
                            <div className={`${navClass} menu-icon`} id="nav-icon3">
                                <span></span>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                    </span>
                </div>
                {this.renderDropdown()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Header.js